export const BREAKPOINTS = {
  sm: '48em',
};

export const MEDIA_QUERY = {
  xs: `(max-width: ${BREAKPOINTS.sm})`,
  sm: `(max-width: ${BREAKPOINTS.sm})`,
};
